import { gql } from "apollo-boost";

export const GET_All_Club_Forms = gql`
  query q3($clubId: Int, $clubFormId: Int) {
    allClubForms(clubId: $clubId, clubFormId: $clubFormId) {
      edges {
        node {
          clubFormId
          clubId
          termsAndConditions
          medicalConsentAuthorization
          waiverOfLiability
          photographPermission
          swimmerRuleConduct
          parentVolunteerTime
          seniorMembersCommitment
          requiredForms
          updateDate
          updateSource
          club {
            id
          }
          id
        }
      }
    }
  }
`;
